import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.lpsysadmin.fund.item');
import { OnInit, Input, OnChanges } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-portal-lpsysadmin-fund-item',
template: templateSource || '',
    styles: [`

/* file: /opt/app/project/main/build/src/app/portal.lpsysadmin.fund.item/view.scss */
:host {
  display: block;
  height: 100%;
}`],
})
export class PortalLpsysadminFundItemComponent implements OnInit, OnChanges {
    constructor(@Inject( Service) public service: Service) { }

    @Input() fund_id: any;
    @Input() menu: any;
    @Input() sub: any;

    public fund: any = null;
    public investments: any = [];
    public operationDraft: any = null;
    public financialDraft: any = null;
    public savingDraft: boolean = false;
    public reportYear: number = new Date().getFullYear();
    public financialYear: number = new Date().getFullYear();
    public yearOptions: number[] = [];

    private ready: boolean = false;

    public async ngOnInit() {
        await this.service.init();
        await this.load();
        this.ready = true;
    }

    public async ngOnChanges(changes: any) {
        if (!this.ready) return;
        if (changes.fund_id) {
            await this.load();
            return;
        }
        if (changes.menu) {
            await this.prepareMenu();
        }
    }

    public async load() {
        this.operationDraft = null;
        this.financialDraft = null;
        if (this.fund_id == "new") {
            this.fund = this.emptyFund();
            this.investments = [];
            this.setupYearOptions();
            await this.service.render();
            return;
        }
        const { code, data } = await wiz.call("info", { id: this.fund_id });
        this.fund = data.info;
        this.investments = data.investments;
        this.setupYearOptions();
        await this.prepareMenu();
        await this.service.render();
    }

    private emptyFund() {
        return {
            id: 'new',
            name: '',
            investment_status: '결성',
            investment_stage: '참여신청',
            payment_method: '일시납',
            investment_resource: '민간',
            type: '개투',
            category: '블라인드',
            mgmt_rate: Array.from({ length: 8 }, () => ({ base: '결성총액', rate: '' })),
            base_rate: { type: 'IRR', value: '' },
            extra: {
                fund_info: '',
                gps: [],
                key_staff_list: [],
                managers: [],
                main_purpose_investments: [],
                mgmt_frequency: 'annual',
                account_name: ''
            },
            visibility: {},
            isnew: true
        };
    }

    public async alert(message: string, status: string = 'error', cancel: any = false, action: string = '확인') {
        return await this.service.alert.show({
            title: "",
            message: message,
            cancel: cancel,
            actionBtn: status,
            action: action,
            status: status
        });
    }

    public linkFundMenu(menu: string) {
        return `/admin/invest/fund/${this.sub}/${this.fund_id}/${menu}`;
    }

    public isActive(link: string) {
        return location.pathname.indexOf(link) === 0
    }

    public activeClass(link: string) {
        if (this.isActive(link)) {
            return "group flex gap-x-3 rounded-md bg-zinc-50 py-2 pl-2 pr-3 text-sm font-semibold leading-6 text-blue-600";
        }
        return "group flex gap-x-3 rounded-md py-2 pl-2 pr-3 text-sm font-semibold leading-6 text-zinc-700 hover:bg-zinc-50 hover:text-blue-600";
    }

    private async prepareMenu() {
        if (!this.fund || this.fund_id == "new") return;
        this.setupYearOptions();
        if (this.menu == "operation-report-write") {
            await this.loadOperationDraft(true);
        }
    }

    public async loadOperationDraft(force: boolean = true, yearValue: any = null) {
        const requestedYear = this.normalizeYear(yearValue === null ? this.reportYear : yearValue, this.reportYear);
        this.reportYear = requestedYear;
        if (!force && this.operationDraft && this.toNumber(this.operationDraft.year) == this.reportYear) return;

        this.operationDraft = { loading: true };
        await this.service.render();

        const { code, data } = await wiz.call("operation_report_draft", {
            id: this.fund_id,
            year: String(requestedYear),
            report_year: String(requestedYear),
            selected_year: String(requestedYear),
            period: `${requestedYear}.12`,
            nonce: Date.now()
        });
        if (code != 200) {
            this.operationDraft = null;
            await this.alert(data?.message || "조합운용보고서 초안을 생성하지 못했습니다.");
            return;
        }

        this.operationDraft = this.normalizeOperationDraft(data.draft || {});
        this.operationDraft.year = requestedYear;
        this.operationDraft.period = `${requestedYear}.12`;
        if (!this.operationDraft.title || /\(20\d{2}\.12\)/.test(String(this.operationDraft.title))) {
            this.operationDraft.title = `${this.fund?.name || ""} 온기영업보고서(${requestedYear}.12)`;
        }
        this.operationDraft.status = this.operationDraft.status || "draft";
        this.reportYear = requestedYear;
        await this.service.render();
    }

    public async loadFinancialDraft(force: boolean = true, yearValue: any = null) {
        const requestedYear = this.normalizeYear(yearValue === null ? this.financialYear : yearValue, this.financialYear);
        this.financialYear = requestedYear;
        if (!force && this.financialDraft && this.toNumber(this.financialDraft.year) == this.financialYear) return;

        this.financialDraft = { loading: true };
        await this.service.render();

        const { code, data } = await wiz.call("financial_statement_draft", {
            id: this.fund_id,
            year: String(requestedYear),
            report_year: String(requestedYear),
            selected_year: String(requestedYear),
            period: `${requestedYear}년`,
            nonce: Date.now()
        });
        if (code != 200) {
            this.financialDraft = null;
            await this.alert(data?.message || "재무제표 초안을 생성하지 못했습니다.");
            return;
        }

        this.financialDraft = data.draft || {};
        this.financialDraft.year = requestedYear;
        this.financialDraft.period = `${requestedYear}년`;
        if (!this.financialDraft.title || /20\d{2}년/.test(String(this.financialDraft.title))) {
            this.financialDraft.title = `${this.fund?.name || ""} ${requestedYear}년 재무제표`;
        }
        this.financialDraft.status = this.financialDraft.status || "draft";
        this.financialYear = requestedYear;
        if (!this.financialDraft.other_expenses) {
            this.financialDraft.other_expenses = [];
        }
        await this.service.render();
    }

    private parseYear(value: any): number {
        if (!value) return 0;
        const match = String(value).match(/(19|20)\d{2}/);
        if (!match) return 0;
        return Number(match[0]);
    }

    private normalizeYear(value: any, fallback: number = new Date().getFullYear()): number {
        const parsed = this.parseYear(value);
        if (parsed) return parsed;
        return Number(fallback) || new Date().getFullYear();
    }

    public setReportYear(value: any) {
        this.reportYear = this.normalizeYear(value, this.reportYear);
    }

    public setFinancialYear(value: any) {
        this.financialYear = this.normalizeYear(value, this.financialYear);
    }

    public yearActionClass(selected: any, year: any): string {
        const active = this.normalizeYear(selected) == this.normalizeYear(year);
        if (active) {
            return "rounded-lg bg-blue-600 px-3 py-2 text-[13px] font-semibold text-white hover:bg-blue-500";
        }
        return "rounded-lg bg-zinc-100 px-3 py-2 text-[13px] font-semibold text-zinc-700 hover:bg-zinc-200";
    }

    private setupYearOptions() {
        const currentYear = new Date().getFullYear();
        const registeredYear = this.parseYear(this.fund?.registered_date);
        const startYear = registeredYear || currentYear - 5;
        const options: number[] = [];
        for (let year = currentYear; year >= startYear; year--) {
            options.push(year);
        }
        if (options.length == 0) options.push(currentYear);
        this.yearOptions = options;
        this.reportYear = this.normalizeYear(this.reportYear, this.yearOptions[0]);
        this.financialYear = this.normalizeYear(this.financialYear, this.yearOptions[0]);
        if (!this.yearOptions.includes(this.reportYear)) this.reportYear = this.yearOptions[0];
        if (!this.yearOptions.includes(this.financialYear)) this.financialYear = this.yearOptions[0];
    }

    private toNumber(value: any): number {
        if (value === null || value === undefined || value === "") return 0;
        if (typeof value === "string") {
            value = value.replace(/,/g, "").replace(/원/g, "").trim();
        }
        const num = Number(value);
        if (Number.isNaN(num)) return 0;
        return num;
    }

    public formatCurrency(value: any): string {
        return `${Math.round(this.toNumber(value)).toLocaleString("ko-KR")}원`;
    }

    private looksCompanyName(value: any): boolean {
        const text = String(value || "");
        return ["주식회사", "(주)", "㈜", "유한회사", "유한책임회사", "사단법인", "재단법인", "합자회사", "합명회사", "법인", "회사"]
            .some(keyword => text.indexOf(keyword) >= 0);
    }

    private investorGroupKey(row: any): string {
        const label = String(row?.label || "").trim();
        const memberType = String(row?.member_type || "").trim();
        if (label == "GP" || memberType == "GP") return "GP";
        if (label == "개인" || memberType == "개인") return "개인";
        if (label == "법인" || memberType == "법인") return "법인";
        return this.looksCompanyName(label) ? "법인" : "개인";
    }

    private groupedInvestorRows(rows: any): any[] {
        const grouped: any = {
            GP: { label: "GP", member_type: "GP", count: 0, amount: 0, paid_amount: 0, distribution_principal: 0, distribution_profit: 0, distribution_total: 0, remaining_amount: 0, distribution_rank: "-" },
            "개인": { label: "개인", member_type: "개인", count: 0, amount: 0, paid_amount: 0, distribution_principal: 0, distribution_profit: 0, distribution_total: 0, remaining_amount: 0, distribution_rank: "-" },
            "법인": { label: "법인", member_type: "법인", count: 0, amount: 0, paid_amount: 0, distribution_principal: 0, distribution_profit: 0, distribution_total: 0, remaining_amount: 0, distribution_rank: "-" }
        };
        const numericKeys = ["amount", "paid_amount", "distribution_principal", "distribution_profit", "distribution_total", "remaining_amount"];
        for (const row of Array.isArray(rows) ? rows : []) {
            if (String(row?.label || "").trim() == "합계") continue;
            const key = this.investorGroupKey(row);
            const target = grouped[key];
            const count = this.toNumber(row?.count);
            target.count += count || 1;
            for (const numericKey of numericKeys) {
                target[numericKey] += this.toNumber(row?.[numericKey]);
            }
            if (row?.distribution_rank && row.distribution_rank != "-") target.distribution_rank = row.distribution_rank;
        }
        return [grouped.GP, grouped["개인"], grouped["법인"]];
    }

    private formatMillion(value: any): string {
        return Math.round(this.toNumber(value) / 1000000).toLocaleString("ko-KR");
    }

    private formatPercent(value: any, total: any): string {
        const denominator = this.toNumber(total);
        if (!denominator) return "";
        return `${(this.toNumber(value) / denominator * 100).toFixed(1)}%`;
    }

    private investorRegisterRowsHtml(rows: any[]): string {
        const totalAmount = rows.reduce((sum: number, row: any) => sum + this.toNumber(row.amount), 0);
        return rows.map((row: any) => {
            const amount = this.toNumber(row.amount);
            const paidAmount = this.toNumber(row.paid_amount);
            const distributionTotal = this.toNumber(row.distribution_total);
            return `<tr>` +
                `<td>${this.escapeHtml(row.label)}</td>` +
                `<td style='text-align:right'>${this.formatMillion(amount)}</td>` +
                `<td style='text-align:right'>${this.formatPercent(amount, totalAmount)}</td>` +
                `<td style='text-align:right'>${this.formatMillion(paidAmount)}</td>` +
                `<td style='text-align:right'>${this.formatPercent(paidAmount, amount)}</td>` +
                `<td style='text-align:right'>${this.formatMillion(row.distribution_principal)}</td>` +
                `<td style='text-align:right'>${this.formatMillion(row.distribution_profit)}</td>` +
                `<td style='text-align:right'>${this.formatMillion(distributionTotal)}</td>` +
                `<td style='text-align:right'>${this.formatPercent(distributionTotal, paidAmount)}</td>` +
                `<td style='text-align:right'>${this.formatMillion(row.remaining_amount)}</td>` +
                `<td>${this.escapeHtml(row.member_type)}</td>` +
                `<td>${this.escapeHtml(row.distribution_rank || "-")}</td>` +
                `</tr>`;
        }).join("");
    }

    private replaceInvestorRegisterTable(content: string, rows: any[]): string {
        if (!content) return content;
        const pattern = /(<h4>\s*◎\s*조합원 구성 및 변경\s*<\/h4>[\s\S]*?<table\b[\s\S]*?<tbody>)([\s\S]*?)(<\/tbody>\s*<\/table>)/i;
        if (!pattern.test(content)) return content;
        return content.replace(pattern, `$1${this.investorRegisterRowsHtml(rows)}$3`);
    }

    private normalizeOperationDraft(draft: any): any {
        const normalized = draft || {};
        const rows = this.groupedInvestorRows(normalized.investor_register);
        normalized.investor_register = rows;
        normalized.content = this.replaceInvestorRegisterTable(String(normalized.content || ""), rows);
        return normalized;
    }

    private operationReportContent(): string {
        return String(this.operationDraft?.content || "");
    }

    public operationReportPageCount(): number {
        const matches = this.operationReportContent().match(/class=["'][^"']*operation-report-page/g);
        if (matches) return matches.length;
        return this.toNumber(this.operationDraft?.page_count);
    }

    public operationReportCompanyPageCount(): number {
        const content = this.operationReportContent();
        const p12 = content.match(/p12\. 투자기업 세부현황/g);
        const p13 = content.match(/p13\. 투자기업 세부현황/g);
        const count = (p12 ? p12.length : 0) + (p13 ? p13.length : 0);
        if (count > 0) return count;
        return this.toNumber(this.operationDraft?.company_detail_page_count);
    }

    private operationReportLabelCount(label: string, fallbackKey: string): number {
        const content = this.operationReportContent();
        const count = content ? content.split(label).length - 1 : 0;
        if (count > 0) return count;
        return this.toNumber(this.operationDraft?.[fallbackKey]);
    }

    public operationReportP12Count(): number {
        return this.operationReportLabelCount("p12. 투자기업 세부현황", "p12_count");
    }

    public operationReportP13Count(): number {
        return this.operationReportLabelCount("p13. 투자기업 세부현황", "p13_count");
    }

    public operationReportIncludes(label: string): boolean {
        return this.operationReportContent().indexOf(label) >= 0;
    }

    public otherExpenseTotal(): number {
        if (!this.financialDraft || !this.financialDraft.other_expenses) return 0;
        return this.financialDraft.other_expenses.reduce((sum: number, row: any) => {
            return sum + this.toNumber(row.amount);
        }, 0);
    }

    public financialTotals() {
        const d = this.financialDraft || {};
        const totalIncome = this.toNumber(d.investment_income) + this.toNumber(d.interest_income) + this.toNumber(d.other_income);
        const totalExpense = this.toNumber(d.management_fee) + this.otherExpenseTotal();
        const netIncome = totalIncome - totalExpense;
        const assetTotal = this.toNumber(d.cash) + this.toNumber(d.investment_assets) + this.toNumber(d.other_assets);
        const equityTotal = this.toNumber(d.contributed_capital) + netIncome;
        return {
            totalIncome,
            totalExpense,
            netIncome,
            assetTotal,
            liabilitiesEquityTotal: this.toNumber(d.liabilities) + equityTotal
        };
    }

    public addOtherExpense() {
        if (!this.financialDraft.other_expenses) this.financialDraft.other_expenses = [];
        this.financialDraft.other_expenses.push({ label: "기타 비용", amount: 0 });
        this.service.render();
    }

    public removeOtherExpense(index: number) {
        if (!this.financialDraft.other_expenses) return;
        this.financialDraft.other_expenses.splice(index, 1);
        this.service.render();
    }

    public async renderFinancialStatement(yearValue: any = null) {
        if (!this.financialDraft) return;
        const requestedYear = this.normalizeYear(yearValue === null ? this.financialYear : yearValue, this.financialYear);
        this.financialYear = requestedYear;
        this.financialDraft.year = requestedYear;
        this.financialDraft.period = `${requestedYear}년`;
        const { code, data } = await wiz.call("render_financial_statement", {
            id: this.fund_id,
            year: String(requestedYear),
            report_year: String(requestedYear),
            data: JSON.stringify(this.financialDraft)
        });
        if (code != 200) {
            await this.alert("재무제표 본문을 갱신하지 못했습니다.");
            return;
        }
        this.financialDraft.content = data.content;
        await this.service.render();
    }

    private escapeHtml(value: any): string {
        return String(value || "")
            .replace(/&/g, "&amp;")
            .replace(/</g, "&lt;")
            .replace(/>/g, "&gt;")
            .replace(/"/g, "&quot;");
    }

    private safeFilename(value: any): string {
        return String(value || "report")
            .replace(/[\\/:*?"<>|]+/g, "_")
            .replace(/\s+/g, " ")
            .trim() || "report";
    }

    private mergeInlineStyle(tag: string, additions: string): string {
        const styleMatch = tag.match(/\sstyle=(["'])(.*?)\1/i);
        if (styleMatch) {
            let style = styleMatch[2].trim();
            if (style && !style.endsWith(";")) style += ";";
            const merged = `${style} ${additions}`.replace(/"/g, "&quot;");
            return tag.replace(styleMatch[0], ` style="${merged}"`);
        }
        return tag.replace(/>$/, ` style="${additions}">`);
    }

    private inlineOperationReportStyles(content: string): string {
        const font = "font-family:'함보총바탕','함초롬바탕','HCR Batang','Batang',serif;";
        const pageStyle = `width:210mm; min-height:297mm; margin:0 auto; padding:18mm; box-sizing:border-box; background:#fff; color:#111827; ${font} font-size:10pt; line-height:1.35; page-break-after:always; break-after:page;`;
        const h3Style = `${font} font-size:13pt; line-height:1.25; margin:0 0 4mm;`;
        const h4Style = `${font} font-size:10.5pt; line-height:1.25; margin:5mm 0 2mm;`;
        const h5Style = `${font} font-size:9.5pt; line-height:1.25; margin:4mm 0 2mm;`;
        const tableStyle = `width:100%; border-collapse:collapse; margin:0 0 7mm; table-layout:fixed; ${font} font-size:9pt; mso-table-lspace:0pt; mso-table-rspace:0pt;`;
        const cellStyle = `border:1px solid #9ca3af; padding:1px 2px; vertical-align:top; ${font} font-size:9pt; line-height:1.15; word-break:keep-all; overflow-wrap:anywhere; mso-border-alt:solid #9ca3af .5pt;`;
        const thStyle = `${cellStyle} background:#f3f4f6; font-weight:700;`;
        return content
            .replace(/<style[\s\S]*?<\/style>/gi, "")
            .replace(/<section([^>]*class=["'][^"']*operation-report-page[^"']*["'][^>]*)>/gi, "<div$1>")
            .replace(/<\/section>/gi, "</div>")
            .replace(/<div\b([^>]*class=["'][^"']*operation-report-page[^"']*["'][^>]*)>/gi, tag => this.mergeInlineStyle(tag, pageStyle))
            .replace(/<h3\b[^>]*>/gi, tag => this.mergeInlineStyle(tag, h3Style))
            .replace(/<h4\b[^>]*>/gi, tag => this.mergeInlineStyle(tag, h4Style))
            .replace(/<h5\b[^>]*>/gi, tag => this.mergeInlineStyle(tag, h5Style))
            .replace(/<table\b[^>]*>/gi, tag => this.mergeInlineStyle(tag, tableStyle))
            .replace(/<th\b[^>]*>/gi, tag => this.mergeInlineStyle(tag, thStyle))
            .replace(/<td\b[^>]*>/gi, tag => this.mergeInlineStyle(tag, cellStyle));
    }

    private normalizedReportContent(content: string, isOperationReport: boolean): string {
        if (!isOperationReport) return content;
        return this.inlineOperationReportStyles(content);
    }

    private reportDocumentHtml(draft: any, type: string = "operation"): string {
        const title = this.escapeHtml(draft?.title || "report");
        const rawContent = String(draft?.content || "");
        const isOperationReport = type == "operation" || rawContent.indexOf("operation-report-page") >= 0;
        const content = this.normalizedReportContent(rawContent, isOperationReport);
        const bodyClass = isOperationReport ? ' class="operation-document"' : "";
        const pageRule = isOperationReport
            ? "@page WordSection1 { size: 210mm 297mm; margin: 0; } @page { size: A4; margin: 0; } div.WordSection1 { page: WordSection1; }"
            : "@page WordSection1 { margin: 18mm; } @page { margin: 18mm; } div.WordSection1 { page: WordSection1; }";
        return `<!doctype html>
<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:w="urn:schemas-microsoft-com:office:word">
<head>
<meta charset="utf-8">
<title>${title}</title>
<!--[if gte mso 9]><xml><w:WordDocument><w:View>Print</w:View><w:Zoom>100</w:Zoom><w:DoNotOptimizeForBrowser/></w:WordDocument></xml><![endif]-->
<style>
body { margin: 0; font-family: "함보총바탕", "함초롬바탕", "HCR Batang", "Batang", serif; color: #111827; line-height: 1.35; padding: ${isOperationReport ? "0" : "32px"}; }
body.operation-document { padding: 0; background: #fff; }
h1 { font-size: 28px; margin: 0 0 24px; }
h2 { font-size: 22px; margin: 0 0 20px; }
h3 { font-size: 18px; margin: 28px 0 12px; }
h4 { font-size: 15px; margin: 20px 0 8px; }
h5 { font-size: 13px; margin: 16px 0 8px; }
p, li { font-size: 12px; }
td, th { font-size: 9pt; }
table { width: 100%; border-collapse: collapse; margin: 0 0 7mm; table-layout: fixed; }
th, td { border: 1px solid #9ca3af; padding: 1px 2px !important; vertical-align: top; line-height: 1.15; word-break: keep-all; overflow-wrap: anywhere; }
th { background: #f3f4f6; font-weight: 700; }
.report-cover { min-height: 240mm; page-break-after: always; break-after: page; }
.operation-report-page { display: block; width: 210mm; min-height: 297mm; margin: 0 auto; padding: 18mm; box-sizing: border-box; font-size: 10pt; line-height: 1.35; page-break-after: always; mso-page-break-after: always; break-after: page; }
.operation-report-page:last-child { page-break-after: auto; mso-page-break-after: auto; break-after: auto; }
.operation-report-page + .operation-report-page { page-break-before: always; break-before: page; }
.operation-report-page h3 { font-size: 13pt; line-height: 1.25; margin: 0 0 4mm; }
.operation-report-page h4 { font-size: 10.5pt; line-height: 1.25; margin: 5mm 0 2mm; }
.operation-report-page h5 { font-size: 9.5pt; line-height: 1.25; margin: 4mm 0 2mm; }
.operation-report-page p { margin: 0 0 3mm; font-size: 9pt; line-height: 1.35; }
.operation-report-page table { width: 100%; border-collapse: collapse; margin: 0 0 7mm !important; table-layout: fixed; font-family: "함보총바탕", "함초롬바탕", "HCR Batang", "Batang", serif; font-size: 9pt; }
.operation-report-page th, .operation-report-page td { border: 1px solid #9ca3af; padding: 1px 2px !important; vertical-align: top; font-family: "함보총바탕", "함초롬바탕", "HCR Batang", "Batang", serif; font-size: 9pt !important; line-height: 1.15; word-break: keep-all; overflow-wrap: anywhere; }
.operation-report-page th { background: #f3f4f6; font-weight: 700; }
.WordSection1 { width: 210mm; margin: 0 auto; }
.report-source-page { width: 210mm; min-height: 297mm; box-sizing: border-box; page-break-after: always; break-after: page; }
.report-source-page:last-child { page-break-after: auto; break-after: auto; }
.report-image-page { width: 210mm; min-height: 297mm; box-sizing: border-box; page-break-after: always; break-after: page; overflow: hidden; }
.report-image-page:last-child { page-break-after: auto; break-after: auto; }
.report-image-page img { display: block; width: 100%; height: auto; }
.report-source-template {
  margin: 0;
  padding: 0;
  border: 0;
  background: transparent;
  white-space: pre;
  font-family: "D2Coding", "Consolas", "Malgun Gothic", monospace;
  font-size: 9.2pt;
  line-height: 1.35;
  color: #111827;
}
section { break-inside: avoid; }
${pageRule}
@media print {
  body { padding: 0; }
  body.operation-document .operation-report-page { margin: 0; }
  table { page-break-inside: auto; }
  tr { page-break-inside: avoid; page-break-after: auto; }
}
</style>
</head>
<body${bodyClass}><div class="WordSection1">${content}</div></body>
</html>`;
    }

    public async exportGeneratedReport(type: string, format: string) {
        let draft = type == "financial" ? this.financialDraft : this.operationDraft;
        if (!draft || !draft.content) {
            await this.alert("출력할 보고서 내용이 없습니다.");
            return;
        }
        if (type == "operation") {
            this.operationDraft = this.normalizeOperationDraft(draft);
            draft = this.operationDraft;
        }

        const html = this.reportDocumentHtml(draft, type);
        const filename = this.safeFilename(draft.title);

        if (format == "word" || format == "hwp") {
            const mimeType = format == "hwp" ? "application/x-hwp;charset=utf-8" : "application/msword;charset=utf-8";
            const extension = format == "hwp" ? "hwp" : "doc";
            const blob = new Blob(["\ufeff", html], { type: mimeType });
            const url = URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.download = `${filename}.${extension}`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(url);
            return;
        }

        const popup = window.open("", "_blank");
        if (!popup) {
            await this.alert("PDF 출력 창을 열 수 없습니다.");
            return;
        }
        popup.document.open();
        popup.document.write(html);
        popup.document.close();
        popup.focus();
        setTimeout(() => popup.print(), 400);
    }

    public async saveGeneratedReport(type: string) {
        let draft = type == "financial" ? this.financialDraft : this.operationDraft;
        if (!draft || draft.loading || !draft.content) {
            if (type == "financial") {
                await this.loadFinancialDraft(true, this.financialYear);
                draft = this.financialDraft;
            } else {
                await this.loadOperationDraft(true, this.reportYear);
                draft = this.operationDraft;
            }
        }
        if (!draft || !draft.title || !draft.content) {
            await this.alert("저장할 초안 내용이 없습니다.");
            return;
        }
        if (type == "operation") {
            this.operationDraft = this.normalizeOperationDraft(draft);
            draft = this.operationDraft;
        }

        this.savingDraft = true;
        await this.service.render();

        const { code } = await wiz.call("save_generated_report", {
            id: this.fund_id,
            title: draft.title,
            content: draft.content,
            status: draft.status || "draft",
            report_type: type,
            year: String(type == "financial" ? this.financialYear : this.reportYear)
        });

        this.savingDraft = false;

        if (code != 200) {
            await this.alert("보고서 저장에 실패했습니다.");
            await this.service.render();
            return;
        }

        await this.alert("조합운용보고 목록에 저장되었습니다.", "success");
        await this.service.render();
    }
}

export default PortalLpsysadminFundItemComponent;